import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { VTextField, VSelect } from 'vuetify/lib';
import CountryState from "./CountryState";
import City from "./City";
import Country from "./Country";
import Model from "./Model";
export class Client extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'client_id',
      fieldTitle: 'Client id',
      component: VTextField,
      content: null
    });
    _defineProperty(this, "ClientId", {
      fieldName: 'client_id',
      fieldTitle: 'Client id',
      component: VTextField,
      content: null
    });
    _defineProperty(this, "ClientFullName", {
      fieldName: 'client_full_name',
      fieldTitle: 'Client full name',
      component: VTextField,
      content: null
    });
    _defineProperty(this, "ClientPhone", {
      fieldName: 'client_phone',
      fieldTitle: 'Client phone',
      component: VTextField,
      content: null
    });
    _defineProperty(this, "ClientAddress", {
      fieldName: 'client_address',
      fieldTitle: 'Client address',
      component: VTextField,
      content: null
    });
    _defineProperty(this, "ClientPostalCode", {
      fieldName: 'client_postal_code',
      fieldTitle: 'Client postal code',
      component: VTextField,
      content: null
    });
    _defineProperty(this, "ClientOtherCity", {
      fieldName: 'client_other_city',
      fieldTitle: 'Client other city',
      component: VTextField,
      content: null
    });
    _defineProperty(this, "ClientCity", {
      fieldName: 'city',
      fieldTitle: 'Client city',
      model: City,
      component: VSelect,
      content: null
    });
    _defineProperty(this, "ClientEmail", {
      fieldName: 'client_email',
      fieldTitle: 'Client email',
      component: VTextField,
      content: null
    });
    _defineProperty(this, "ClientRegion", {
      fieldName: 'client_region',
      fieldTitle: 'Client region',
      model: CountryState,
      component: VSelect,
      content: null
    });
    _defineProperty(this, "ClientOtherRegion", {
      fieldName: 'client_other_region',
      fieldTitle: 'Client other region',
      component: VTextField,
      content: null
    });
    _defineProperty(this, "ClientIpAddress", {
      fieldName: 'ip_address',
      fieldTitle: 'Client ip address',
      content: null
    });
    _defineProperty(this, "Country", {
      fieldName: 'country',
      fieldTitle: 'Client Country',
      model: Country,
      component: VSelect,
      content: null
    });
  }
  getId() {
    return this.Id.content;
  }
  getFullName() {
    return this.ClientFullName.content;
  }
  getCountry() {
    return this.Country.content;
  }
  getPhone() {
    return this.ClientPhone.content;
  }
  getAddress() {
    return this.ClientAddress.content;
  }
  getRegion() {
    return this.ClientRegion.content;
  }
  getRegionNativeName() {
    let region = this.getRegion();
    return region instanceof CountryState ? region.getNativeName() : null;
  }
  getRegionName() {
    let region = this.getRegion();
    return region instanceof CountryState ? region.getName() : null;
  }
  getCustomRegionName() {
    return this.ClientOtherRegion.content;
  }
  getCity() {
    return this.ClientCity.content;
  }
  getCityNativeName() {
    let city = this.getCity();
    return city instanceof City ? city.getNativeName() : null;
  }
  getCityName() {
    let city = this.getCity();
    return city instanceof City ? city.getName() : null;
  }
  getCityCustomName() {
    return this.ClientOtherCity.content;
  }
}
export default Client;